<template>
  <div v-loading="loading">
    <el-row
        v-if="device.mac_address"
        :gutter="20"
        class="form-row">
      <el-col :span="12">
        <label>Old Product Type</label>
        <el-input
            readonly
            class="highlight"
            :value="currentProduct.description"
            name="old_product_type" />
      </el-col>
      <el-col :span="12">
        <label>Old Product Color</label>
        <el-input
            readonly
            class="highlight"
            :value="device.profile.color || 'N/D'"
            name="old_product_color" />
      </el-col>
    </el-row>
    <el-row
        :gutter="20"
        class="form-row">
      <el-col :span="24">
        <label>Reason Group</label>
        <el-tooltip
            class="item"
            effect="dark"
            content="Refresh data"
            placement="top">
          <RefreshButton
              class="flex-shrink"
              style="padding: 0"
              :text="false"
              @click="refreshReasons" />
        </el-tooltip>
        <div class="el-input">
          <el-select
              v-model="request_reasons.reason_group"
              filterable
              clearable
              placeholder="Please select group"
              name="reason_group"
              @change="resetReason()">
            <el-option
                v-for="group in currentGroups"
                :key="group.id"
                :label="group.value"
                :value="group.id" />
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row
        :gutter="20"
        class="form-row">
      <el-col :span="24">
        <div
            class="clearfix"
            style="margin-bottom: 5px;">
          <label>
            Reason
            <el-tag
                v-if="request_reasons.return_label"
                type="warning"
                effect="plain"
                size="mini">With Return Label</el-tag>
          </label>
        </div>
        <div class="el-input">
          <el-select
              v-model="new_reason.id"
              filterable
              clearable
              :disabled="!request_reasons.reason_group"
              placeholder="Please select reason"
              name="reason"
              @change="setReturnLabel">
            <el-option
                v-for="reason in currentReasons"
                :key="reason.id"
                :label="`${reason.value} - ${reason.text}`"
                :value="reason.id">
              <span style="float: left">{{ reason.value }} - {{ reason.text }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ reason.return_label ? 'With Return Label' : '' }}</span>
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <div class="center-buttons">
      <el-button
          plain
          @click="back()">
        Back
      </el-button>
      <el-button
          type="info"
          plain
          @click="reset()">
        Reset
      </el-button>
      <el-button
          :disabled="!isValid"
          type="primary"
          plain
          @click="next()">
        Next
      </el-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { createNamespacedHelpers as h } from "vuex";
import { clone } from "lodash";
import RefreshButton from "@/containers/Customer/RefreshButton.vue";

const { mapGetters: sharedGetters, mapActions: sharedActions } = h("shared");
const { mapActions: requestActions, mapGetters: requestGetters } =
  h("db/requests");

export default {
  name: "CustomerRequestRefundReasonStep",
  components: { RefreshButton },
  props: {
    device: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      valid: false,
      currentGroup: null,
      loading: false,
      new_reason: { quantity: 1, id: null },
      request_reasons: {
        reason_group: null,
        reasons: [],
      },
    };
  },
  computed: {
    ...sharedGetters(["products", "reasons", "groups"]),
    ...requestGetters(["requestInProgress"]),
    isValid() {
      return !!this.request_reasons.reason_group && !!this.new_reason.id;
    },
    currentKind() {
      return this.device.type || this.device.kind || this.device.profile.kind;
    },
    currentProduct() {
      return this.products.find((p) => p.kind === this.currentKind);
    },
    currentGroups() {
      return this.groups.filter((group) => {
        return group.key == this.requestInProgress.general.type.toLowerCase();
      });
    },
    currentReasons() {
      return this.reasons.filter((reason) => {
        return (
          reason.reason_group_id == this.request_reasons.reason_group &&
          reason.kinds.indexOf(this.currentKind) > -1
        );
      });
    },
  },
  created() {
    this.refreshReasons();
    this.parseDataFromStore();
  },
  methods: {
    ...requestActions(["setProductInformation", "setReasonInformation"]),
    ...sharedActions(["fetchReasons", "fetchProducts"]),
    parseDataFromStore() {
      if (Object.keys(this.requestInProgress.reasons).length > 0) {
        this.request_reasons.reasons = clone(
          this.requestInProgress.reasons.reasons
        );
        this.request_reasons.reason_group = clone(
          this.requestInProgress.reasons.reason_group
        );
        this.new_reason = this.request_reasons.reasons[0] || {};
      }
    },
    addNewReason() {
      this.request_reasons.reasons[0] = this.new_reason || {};
    },
    next() {
      this.request_reasons.reasons = [this.new_reason];
      this.setReasonInformation(this.request_reasons);
      this.$emit("next");
    },
    reset() {
      this.setReasonInformation({}).then(() => {
        this.request_reasons = {
          reason_group: null,
          reasons: [{}],
        };
      });
    },
    back() {
      this.$emit("back");
    },
    refreshReasons() {
      this.fetchReasons()
        .then(() => console.log("success fetch reasons"))
        .catch(() => console.log("error fetch reasons"))
        .finally(() => {
          this.request_reasons.reason_group = null;
        });
    },
    getReason(id) {
      return (
        this.reasons.find((r) => {
          return r.id === id;
        }) || {}
      );
    },
    resetReason() {
      this.request_reasons.reasons = [{}];
      this.new_reason = { id: "", quantity: 1 };
    },
    setReturnLabel(selectedReason) {
      let selectedId = selectedReason;
      let reason = this.currentReasons.find((r) => r.id === selectedId);
      this.request_reasons.return_label = reason.return_label;
    },
  },
};
</script>

<style lang="css">
.el-select {
  width: 100%;
}
</style>
